import React, { useEffect, useState, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { Dropdown, DropdownProps, DropdownItemProps, Header } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import { token_config } from '../../../AppContext';
import axiosInstance from '../../../helpers/axiosInstance';
import { acquireIdToken } from '../../../helpers/azureAuth';
import { IdNameViewModel } from '../../../types/ServerDTO';
import AppContext from '../../../AppContext';
import './UserInfo.css';

const UserInfo: React.FC = () => {
  const location = useLocation();
  const [officeId, setOfficeId] = useState<any>(0);
  const [disabledOfficeDropdown, setDisabledOfficeDropdown] = useState<boolean>(false);
  const [offices, setOffices] = useState<IdNameViewModel[]>([]);
  const [username, setUsername] = useState<string | null>(null);
  const { userInfo } = useContext(AppContext);

  useEffect(() => {
    if (location.pathname === '/case' || location.pathname === '/constituent' || location.pathname.indexOf('/case/') !== -1 || location.pathname.indexOf('/constituent/') !== -1) {
      setDisabledOfficeDropdown(true);
    }
  }, []);

  useEffect(() => {
    if (userInfo) {
      try {
        setUsername(userInfo.FullName);
        const privileges: string[] = userInfo.Privileges.split(',');
        if (privileges.includes(token_config.MANAGE_USERS) && officeId === 0) {
          fetchOffices();
          setOfficeId(parseInt(userInfo.OfficeId));
        }
      } catch (error) {
        console.error('Invalid JWT:', error);
      }
    }
  }, [userInfo]);

  const fetchOffices = async () => {
    try {
      await axiosInstance.get(`/Auth/GetOffices`).then(({ data, status }) => {
        if (status === 200) {
          setOffices(data);
        }
      })
        .catch((error: any) => {
          console.log(error);
        });
    } catch (error: any) {
      console.log(error);
    }
  }

  const convertToDropDownProps = (MasterItems: Array<IdNameViewModel>) => {
    return (MasterItems || []).map((item: IdNameViewModel) => ({
      key: item.id,
      text: item.name,
      value: item?.id,
    } as DropdownItemProps));
  }

  const handleDropdownChange = async (event: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => {
    const { value } = data;
    setOfficeId(value);
    if (userInfo) {
      try {
        let idToken = null;
        let tmpAccessToken = null;
        if (userInfo.AuthenticationTypeId === "1") {
          idToken = await acquireIdToken();
        } else if (userInfo.AuthenticationTypeId === "2") {
          tmpAccessToken = localStorage.getItem(token_config.ACCESS_TOKEN);
        }
        const payload = {
          accessToken: tmpAccessToken,
          idToken,
          officeId: value,
          authenticationTypeId: userInfo.AuthenticationTypeId,
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        }
        await axiosInstance.post(`/Auth/ReLogin`, payload).then(({ data, status }) => {
          if (status === 200) {
            localStorage.setItem(token_config.ACCESS_TOKEN, data.accessToken);
            if (data.refreshToken) {
              localStorage.setItem(token_config.REFRESH_TOKEN, data.refreshToken);
            }
            window.location.reload();
          }
        })
          .catch((error: any) => {
            console.log(error);
          });
      } catch (error: any) {
        console.log(error);
      }
    }
  };

  if (!username) {
    return (null);
  }

  return (
    <>
      <Header as="span" className='user-info active' style={{ whiteSpace: 'nowrap', marginTop: '0rem' }}>
        {username}
      </Header>
      {offices?.length > 0 && (
        <Dropdown
          name="officeId"
          options={convertToDropDownProps(offices || [])}
          fluid
          selection
          value={officeId}
          onChange={handleDropdownChange}
          style={{ width: '155px', marginRight: '1rem' }}
          disabled={disabledOfficeDropdown}
        />
      )}
    </>
  );
};

export default UserInfo;